import { IMParticleUserIdentity } from './types';

export const createMparticleIdentity = (
  email: string,
  customerid: string,
  ccToken: string
): IMParticleUserIdentity => {
  return { email, customerid, other3: ccToken };
};
